import type { Metadata } from "next";
import type { AlternateLinkDescriptor } from "next/dist/lib/metadata/types/alternative-urls-types";
import { getLang } from "./shared";

const parseSlug = (
  slug: string | URL | AlternateLinkDescriptor[] | null | undefined
) => {
  if (slug instanceof URL) {
    return slug.pathname;
  }

  if (Array.isArray(slug) && slug[0]?.url) {
    return parseSlug(slug[0].url);
  }

  if (typeof slug === "string") {
    return slug;
  }

  return null;
};

/**
 * Generates a route manifest for internationalized slugs
 */
export const generateRouteManifest = (
  alternates: NonNullable<Metadata["alternates"]>["languages"],
  languageOnly: boolean = true
) => {
  const entries = Object.entries(alternates || {}).map(([geo, slug]) => {
    const locale = languageOnly ? getLang(geo) : geo;
    const parsedSlug = parseSlug(slug);
    return {
      hrefLang: locale,
      href: parsedSlug || "/",
      lang: getLang(geo),
    } satisfies Route;
  });

  return JSON.stringify(entries);
};

export interface Route {
  hrefLang: string;
  href: string;
  lang: string;
}

export type RouteManifest = Route[];
